/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

jQuery(function($) {

  $(document).on('click', '.house-about-wrapper .more-btn', function(e){
    e.preventDefault();

    $(this).toggleClass('open-more');

    $('.house-about-wrapper .more-info-wrapper').slideToggle(300);
  });

  if ( $('.amenities-wrapper').length ){

    let amenitiesWrapper = $('.amenities-wrapper');

    if ( amenitiesWrapper.find('.amenities-list .item').length > 10 ){
      amenitiesWrapper.find('.more-btn').removeClass('d-none');
    }

    amenitiesWrapper.find('.amenities-list .item').each(function (index){
      let thisItem = $(this);

      if ( index > 9 ){
        thisItem.addClass('d-none');
      }

    });

    amenitiesWrapper.find('.more-btn').on('click', function (e){
      e.preventDefault();

      $(this).addClass('d-none');
      amenitiesWrapper.find('.amenities-list .item').removeClass('d-none');

    });

  }

  if ( $('#rooms-slider').length ){

    let thisBlock = $('.room-slider-wrapper');

    let slidesCount = thisBlock.find('#rooms-slider .slide:not(.slick-cloned)').length;

    if (slidesCount < 3) {
      thisBlock.find('.controls-wrapper').addClass('d-none');

      thisBlock.find('#rooms-slider').addClass('short');

      thisBlock.find('#rooms-slider').slick({
        autoplay: false,
        autoplaySpeed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: true,
              fade: true
            }
          },
        ]
      });
    }else if (slidesCount == 3){

      thisBlock.find('#rooms-slider').addClass('short');

      thisBlock.find('#rooms-slider').slick({
        autoplay: false,
        autoplaySpeed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              fade: true,
              dots: true
            }
          },
        ]
      });
    }else{
      thisBlock.find('#rooms-slider').slick({
        autoplay: false,
        autoplaySpeed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              dots: true,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              dots: true
            }
          },
        ]
      });
    }

    thisBlock.find('.control.prev').click(function(e){
      e.preventDefault();

      thisBlock.find('#rooms-slider').slick('slickPrev');
    });

    thisBlock.find('.control.next').click(function(e){
      e.preventDefault();

      thisBlock.find('#rooms-slider').slick('slickNext');
    });
  }
});
